import PropTypes from 'prop-types';
import React from 'react';
import ChordOverlay from '../../../components/ChordOverlay';

const LessonChords = ({ chords }) => {
  return (
    <div className="lesson-chords">
      <ChordOverlay chords={chords} />
    </div>
  );
};

LessonChords.propTypes = {
  chords: PropTypes.arrayOf(PropTypes.shape({})),
};

LessonChords.defaultProps = {
  chords: [],
};

export default LessonChords;
